import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FuseAnimate} from '@fuse';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';
import { Paper, Grid, Button, Divider, Typography, Dialog, DialogContent, LinearProgress, DialogTitle, DialogContentText, DialogActions, List, ListItem, ListItemText } from '@material-ui/core';
import Pagination from "material-ui-flat-pagination";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import Timeline from './Timeline';
import { prosesSubIndikator } from '../../../store/actions/RaporMutu.actions';

const styles = theme => ({
    layoutRoot: {},
    pagingPeringkat: {
        textAlign: 'right'
    },
    tabSelected: {
        borderBottom: '5px solid #4EBAE7',
        background: '#ECEFF1',
        color: 'white'
    },
});

// function getSteps() {
//     return [
//         'Mengisi kuesioner  untuk tiga responden', 
//         'Menghitung rapor mutu tiga responden',
//         'Mengisi kuesioner untuk kepala sekolah',
//         'Menghitung rapor mutu sekolah',
//         'Verifikasi rapor mutu oleh Pengawas',
//         'Pakta Integritas Kepala Sekolah'
//     ];
// }

class RiwayatRaporMutu extends Component {
    state = {
        error:0,
        routeParams:{
            jenis_rapor_id: "1"
        },
        valueTab: 0,
        offset: 0,
        total: 0,
        openDialog: false,
        completed: 0,
        fullWidth: true,
        maxWidth: 'sm',
        tampilCheck: ['none','none','none','none','none','none'],
        disabledButtonTigaResponden: true,
        showButtonTigaResponden: true,
        disabledButtonSekolah: true,
        showButtonSekolah: false,
        check: {
            kepsek: false,
            komite: false,
            pd: false,
            ptk: false,
            total: false
        },
        kemajuan_kepsek: [],
        kemajuan_ptk: [],
        kemajuan_pd: [],
        kemajuan_komite: [],
        kemajuan_total: [],
        activeStep: 1,
        prosesJalan: false,
        prosesGagal: false,
        prosesStatus: {
            proses1: false,
            proses2: false,
            proses3: false,
            proses4: false,
            proses5: false,
            proses6: false,
            proses7: false,
            persenProses: 0
        }
    }

    goTolink = (url) => {
        this.props.history.push(url);
    };

    componentDidMount = () => {
        this.props.setJudul('Rapor Mutu');

        this.props.getKemajuanTotal(this.state.routeParams).then((result)=>{
            // console.log(this.props.kemajuan_total);

            const array = this.props.kemajuan_total.rows;

            console.log(array)

            let arrayCheck = this.state.check
            let kemajuan_ptk = []
            let kemajuan_kepsek = []

            for (let index = 0; index < array.length; index++) {
                const option = array[index];
                
                if(Number(option.peran_id) === 10){
                    
                    kemajuan_kepsek = option
                    if(parseInt(localStorage.getItem('simulasi_hitung')) === 1){
                        if(Number(option.peran_id) === 10 && parseFloat(option.persentase) !== 100){
                            arrayCheck = {
                                ...arrayCheck,
                                kepsek: true
                            }
    
                        }
                    }else{
                        if(Number(option.peran_id) === 10 && parseFloat(option.persentase) === 100){
                        // if(Number(option.peran_id) === 10 && parseFloat(option.persentase) !== 100){
                            arrayCheck = {
                                ...arrayCheck,
                                kepsek: true
                            }
    
                        }
                    }

            //         this.setState({
            //             ...this.state,
            //             kemajuan_kepsek: option
            //         },()=>{
            //             if(Number(option.peran_id) === 10 && parseFloat(option.persentase) === 100){
            //                 this.setState({
            //                     ...this.state,
            //                     check: {
            //                         ...this.state.check,
            //                         kepsek: true
            //                     }
            //                 });
            //             }
            //         });
                }

                if(Number(option.peran_id) === 53){
                    
                    kemajuan_ptk = option

                    if(parseInt(localStorage.getItem('simulasi_hitung')) === 1){
                        if(Number(option.peran_id) === 53 && parseFloat(option.persentase) !== 100){
                            arrayCheck = {
                                ...arrayCheck,
                                ptk: true
                            }
    
                        }
                    }else{
                        if(Number(option.peran_id) === 53 && parseFloat(option.persentase) === 100){
                        // if(Number(option.peran_id) === 53 && parseFloat(option.persentase) !== 100){
                            arrayCheck = {
                                ...arrayCheck,
                                ptk: true
                            }
    
                        }
                    }

            //         this.setState({
            //             ...this.state,
            //             kemajuan_ptk: option
            //         },()=>{
            //             if(Number(option.peran_id) === 53 && parseFloat(option.persentase) === 100){
            //                 this.setState({
            //                     ...this.state,
            //                     check: {
            //                         ...this.state.check,
            //                         ptk: true
            //                     }
            //                 });
            //             }
            //         });
                }

            //     // if(Number(option.peran_id) === 90){

            //     //     this.setState({
            //     //         ...this.state,
            //     //         kemajuan_pd: option
            //     //     },()=>{
            //     //         if(Number(option.peran_id) === 90 && parseFloat(option.persentase) === 100){
            //     //             this.setState({
            //     //                 ...this.state,
            //     //                 check: {
            //     //                     ...this.state.check,
            //     //                     pd: true
            //     //                 }
            //     //             });
            //     //         }
            //     //     });
            //     // }

            //     // if(Number(option.peran_id) === 14){

            //     //     this.setState({
            //     //         ...this.state,
            //     //         kemajuan_komite: option
            //     //     },()=>{
            //     //         if(Number(option.peran_id) === 14 && parseFloat(option.persentase) === 100){
            //     //             this.setState({
            //     //                 ...this.state,
            //     //                 check: {
            //     //                     ...this.state.check,
            //     //                     komite: true
            //     //                 }
            //     //             });
            //     //         }
            //     //     });
            //     // }

            //     // if(Number(option.peran_id) === 99){

            //     //     this.setState({
            //     //         ...this.state,
            //     //         kemajuan_total: option
            //     //     },()=>{
            //     //         if(Number(option.peran_id) === 99 && parseFloat(option.persentase) === 100){
            //     //             this.setState({
            //     //                 ...this.state,
            //     //                 disabledButtonSekolah: false,
            //     //                 showPeringatanSekolah: false,
            //     //                 check: {
            //     //                     ...this.state.check,
            //     //                     total: true
            //     //                 }
            //     //             },()=>{
            //     //                 console.log(this.state);
            //     //             });
            //     //         }
            //     //     });
            //     // }
            };

            // console.log(arrayCheck)
            // if(arrayCheck.kepsek && arrayCheck.ptk){
            //     let state = 
            // }

            this.setState({
                check: arrayCheck,
                showPeringatanSekolah: (arrayCheck.kepsek && arrayCheck.ptk ? false : true),
                disabledButtonSekolah: (arrayCheck.kepsek && arrayCheck.ptk ? false : true),
                kemajuan_kepsek: kemajuan_kepsek,
                kemajuan_ptk: kemajuan_ptk
            },()=>{
                console.log(this.state)
            })

            // this.setState({
            //     ...this.state,
            //     kemajuan_kepsek: {
            //         ...this.state.kemajuan_kepsek,
            //         persentase: 100
            //     },
            //     kemajuan_pd: {
            //         ...this.state.kemajuan_pd,
            //         persentase: 100
            //     },
            //     kemajuan_ptk: {
            //         ...this.state.kemajuan_ptk,
            //         persentase: 100
            //     },
            //     kemajuan_komite: {
            //         ...this.state.kemajuan_komite,
            //         persentase: 100
            //     },
            //     check: {
            //         kepsek: true,
            //         komite: true,
            //         pd: true,
            //         ptk: true,
            //         total: true
            //     }
            // },()=>{
            //     console.log(this.state.kemajuan_kepsek.persentase);
            //     console.log(this.state.kemajuan_pd.persentase);
            //     console.log(this.state.kemajuan_ptk.persentase);
            //     console.log(this.state.kemajuan_komite.persentase);
    
            //     if(parseFloat(this.state.kemajuan_kepsek.persentase) === 100 || parseFloat(this.state.kemajuan_ptk.persentase) === 100){
            //     // if(parseFloat(this.state.kemajuan_kepsek.persentase) === 100 || parseFloat(this.state.kemajuan_pd.persentase) === 100 || parseFloat(this.state.kemajuan_ptk.persentase) === 100 || parseFloat(this.state.kemajuan_komite.persentase) === 100){
            //     // if(this.state.kemajuan_kepsek.persentase === 100 || this.state.kemajuan_pd.persentase !== 100 || this.state.kemajuan_ptk.persentase !== 100 || this.state.kemajuan_komite.persentase !== 100){
            //         this.setState({
            //             ...this.state,
            //             disabledButtonSekolah: false,
            //             showPeringatanSekolah: false
            //         });
            //     }else{
            //         this.setState({
            //             ...this.state,
            //             // disabledButtonSekolah: false,
            //             // showPeringatanSekolah: false
            //             disabledButtonSekolah: true,
            //             showPeringatanSekolah: true
            //         })
            //     }
    
            //     console.log(this.state)
    
            // });
        });

        // if(this.state.kemajuan_pd.persentase === 100 || this.state.kemajuan_ptk.persentase !== 100 || this.state.kemajuan_komite.persentase !== 100){
        //     this.setState({
        //         ...this.state,
        //         disabledButtonTigaResponden: true,
        //         showPeringatanTigaResponden: true
        //     });
        // }else{
        //     this.setState({
        //         ...this.state,
        //         disabledButtonTigaResponden: false,
        //         showPeringatanTigaResponden: false
        //     })
        // }

        // //override everything
        // this.setState({
        //     ...this.state,
        //     disabledButtonSekolah: false,
        //     showPeringatanSekolah: false
        // });

    }

    handleChangeTab = (event, value) => {
        this.setState({
            valueTab: value
        });
    }

    loadData = (e, offset) => {
        // console.log(offset);
        this.setState({
            offset: offset,
            routeParams: {
                ...this.state.routeParams,
                jenis_rapor_id: localStorage.getItem('jenis_rapor_id'),
                pengguna_id: JSON.parse( localStorage.getItem('user') ).pengguna_id,
                sekolah_id: JSON.parse( localStorage.getItem('user') ).sekolah_id,
                token: localStorage.getItem('jwt_token'),
                tahun: localStorage.getItem('tahun'),
                instrumen_id: localStorage.getItem('instrumen_id'),
                start: offset
            }
        },()=>{
            this.props.getProsesRapor(this.state.routeParams).then((result)=>{
                // console.log(this.props.proses_rapor_mutu);
            });
        });
    }

    prosesRaporMutu = (e) => {

        // this.props.setLoading(true)
        this.setState({
            prosesJalan:true,
            prosesStatus: {
                proses1: false,
                proses2: false,
                proses3: false,
                proses4: false,
                proses5: false,
                persenProses: 0
            }
        },()=>{
            
            this.props.getSekolah({sekolah_id: JSON.parse( localStorage.getItem('user') ).sekolah_id}).then((result)=>{

                setTimeout(() => {
                    
                    this.setState({
                        prosesStatus: {
                            ...this.state.prosesStatus,
                            proses1: true
                        },
                        sekolah: result.payload
                    },()=>{

                        this.props.cekSekolah({
                            alamat: parseInt(localStorage.getItem('simulasi_hitung')) === 1 ? "118.98.166.54:5774" : window.location.hostname+":5774", 
                            sekolah_id:JSON.parse( localStorage.getItem('user') ).sekolah_id, 
                            npsn:this.state.sekolah.npsn
                        }).then((result)=>{

                            console.log(result)

                            // if(!result.payload.mngafgak){
                            //     alert('mantab')
                            // }


                            if(result.payload.results){
                                if(parseInt(result.payload.results) > 0){

                                    let start = 0;
                                    let limit = 10;
                                    let total = 225;
            
                                    for (let indexQuery = 0; indexQuery < total; indexQuery++) {
                                        // const element = array[indexQuery];
                                        // if(indexQuery / limit)
                                        if(indexQuery % limit === 0){
                                            // console.log(indexQuery)
                                            this.props.prosesDatamart({
                                                // dikomen dulu ah
                                                alamat: parseInt(localStorage.getItem('simulasi_hitung')) === 1 ? "118.98.166.54:5774" : window.location.hostname+":5774", 
                                                start:indexQuery, 
                                                limit:limit, 
                                                sekolah_id:JSON.parse( localStorage.getItem('user') ).sekolah_id, 
                                                npsn:this.state.sekolah.npsn
                                            }).then((result)=>{
                                                // // console.log(result.payload)
                                                // console.log(result.payload)
                                                // return true
            
                                                this.setState({
                                                    prosesStatus: {
                                                        ...this.state.prosesStatus,
                                                        // proses2: true,
                                                        persenProses: parseInt(this.state.prosesStatus.persenProses)+1
                                                    }
                                                },()=>{
                    
                                                    let bentuks = ''
                    
                                                    switch (this.state.sekolah.bentuk_pendidikan_id) {
                                                        case 53:
                                                            bentuks = 5
                                                            break;
                                                        case 54:
                                                            bentuks = 6
                                                            break;
                                                        case 55:
                                                            bentuks = 13
                                                            break;
                                                        default:
                                                            bentuks = this.state.sekolah.bentuk_pendidikan_id
                                                            break;
                                                    }
                                                    
                                                    if(parseInt(this.state.prosesStatus.persenProses) === 23){
            
                                                        this.setState({
                                                            prosesStatus: {
                                                                ...this.state.prosesStatus,
                                                                proses2: true
                                                            }
                                                        },()=>{
            
                                                            this.props.prosesRaporMutuDapodik({sekolah_id:JSON.parse( localStorage.getItem('user') ).sekolah_id, npsn:this.state.sekolah.npsn, bentuk_pendidikan_id:bentuks}).then((result)=>{
                                                                // console.log(result.payload)
                                                                this.setState({
                                                                    prosesStatus: {
                                                                        ...this.state.prosesStatus,
                                                                        // proses3: true
                                                                        // proses4: true
                                                                    }
                                                                },()=>{
            
                                                                    this.props.prosesRaporMutuDapodik({sekolah_id:JSON.parse( localStorage.getItem('user') ).sekolah_id, npsn:this.state.sekolah.npsn, bentuk_pendidikan_id:bentuks}).then((result)=>{
                                                                        // console.log(result.payload)
                                                                        this.props.prosesNonDatamart({
                                                                            sekolah_id:JSON.parse( localStorage.getItem('user') ).sekolah_id, 
                                                                            npsn:this.state.sekolah.npsn, 
                                                                            bentuk_pendidikan_id:bentuks,
                                                                            alamat: parseInt(localStorage.getItem('simulasi_hitung')) === 1 ? "118.98.166.54:5774" : window.location.hostname+":5774"
                                                                        }).then((result)=>{
            
                                                                            this.setState({
                                                                                prosesStatus: {
                                                                                    ...this.state.prosesStatus,
                                                                                    proses3: true
                                                                                    // proses4: true
                                                                                }
                                                                            },()=>{
                                                                            
                                                                                //proses rapor mutu sub indikator
                                                                                this.props.prosesSubIndikator({sekolah_id:JSON.parse( localStorage.getItem('user') ).sekolah_id }).then((result)=>{
                                                                                    this.setState({
                                                                                        prosesStatus: {
                                                                                            ...this.state.prosesStatus,
                                                                                            proses4: true
                                                                                        }
                                                                                    },()=>{
                                                                                        
                                                                                        //proses rapor mutu indikator
                                                                                        this.props.prosesIndikator({sekolah_id:JSON.parse( localStorage.getItem('user') ).sekolah_id }).then((result)=>{
                                                                                            this.setState({
                                                                                                prosesStatus: {
                                                                                                    ...this.state.prosesStatus,
                                                                                                    proses5: true
                                                                                                }
                                                                                            },()=>{
                                                                                                //proses rapor mutu standar
                                                                                                this.props.prosesStandar({sekolah_id:JSON.parse( localStorage.getItem('user') ).sekolah_id }).then((result)=>{
                                                                                                    this.setState({
                                                                                                        prosesStatus: {
                                                                                                            ...this.state.prosesStatus,
                                                                                                            proses6: true
                                                                                                        }
                                                                                                    },()=>{
                                                                                                        this.props.prosesLogRapor({
                                                                                                            sekolah_id: JSON.parse( localStorage.getItem('user') ).sekolah_id,
                                                                                                            pengguna_id: JSON.parse( localStorage.getItem('user') ).pengguna_id, 
                                                                                                            instrumen_id: localStorage.getItem('instrumen_id')
                                                                                                        }).then((result)=>{
                                                                                                            
                                                                                                        })
                                                                                                    })
                                                                                                })
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                })
                
                                                                            })
            
                                                                        })
                                                                        
                                                                    })
                                                                    
                                                                })
                                        
                                                            })
            
                                                        })
                                                        
            
                                                    }
            
                    
                                                })
                        
                                            })
                                        }
                                        // console.log(indexQuery % limit)
            
                                        // limit = limit + 10
            
            
                                    }

                                    console.log('sekolah ditemukan')

                                }else{
                                    console.log('sekolah tidak ditemukan')
                                    
                                    this.setState({
                                        ...this.state,
                                        prosesGagal: true,
                                        prosesJalan: false
                                    })
                                }
                            }else{
                                console.log('sekolah tidak ditemukan')


                                this.setState({
                                    ...this.state,
                                    prosesGagal: true,
                                    prosesJalan: false
                                })
                            }

                        })
                        // return true


                        // return true;
    
    
                    })

                }, 2000);
    
            })

        })


    }

    // prosesRaporMutu = (e) => {
    //     // alert('tes');
    //     this.timer = setInterval(() => {
    //         if(this.state.completed < 25){
    //             this.setState({
    //                 completed: (this.state.completed+10)
    //             });
    //         }
    //     }, 500);

    //     this.setState({
    //         ...this.state,
    //         openDialog: true,
    //         routeParams: {
    //             ...this.state.routeParams,
    //             pengguna_id: JSON.parse( localStorage.getItem('user') ).pengguna_id,
    //             sekolah_id: JSON.parse( localStorage.getItem('user') ).sekolah_id,
    //             token: localStorage.getItem('jwt_token'),
    //             tahun: localStorage.getItem('tahun'),
    //             instrumen_id: localStorage.getItem('instrumen_id'),
    //             jenis_rapor_id: localStorage.getItem('jenis_rapor_id'),
    //             jenis_notifikasi_id: 4
    //         }
    //     },()=>{

    //         this.props.hitungMasterPMP(this.state.routeParams).then((result)=>{
    //             this.setState({
    //                 completed: 90,
    //                 tampilCheck: ['inline','inline','inline','inline','inline','none']
    //             },()=>{
    //                 this.props.prosesRaporMutu(this.state.routeParams).then((result)=>{
    //                     this.setState({
    //                         completed: 100,
    //                         tampilCheck: ['inline','inline','inline','inline','inline','inline']
    //                     },()=>{
    //                         this.props.getProsesRapor(this.state.routeParams);
    //                         this.props.setActiveStep(2);
    //                         this.props.getTimeline(this.state.routeParams);

    //                         this.props.getSekolah(this.state.routeParams).then((result)=>{
                                
    //                             this.setState({
    //                                 ...this.state,
    //                                 routeParams: {
    //                                     ...this.state.routeParams,
    //                                     keterangan: JSON.parse( localStorage.getItem('user') ).nama + ' melakukan penghitungan rapor mutu sekolah untuk ' + this.props.sekolah.nama,
    //                                     tautan: '/HasilRaporMutu',
    //                                     tujuan_notifikasi_id: 1,
    //                                     jenis_notifikasi_id: 4
    //                                 }
    //                             });
                                
    //                             this.props.setNotifikasi(this.state.routeParams);
    //                         });
    //                     })
    //                 });
    //             });
    //         });

    //         // this.props.prosesRaporMutu(this.state.routeParams);
    //         // this.props.hitungFinalSkor(this.state.routeParams).then((result)=>{
    //         //     this.setState({
    //         //         completed: 25,
    //         //         tampilCheck: ['inline','none','none','none','none','none']
    //         //     },()=>{
    //         //         this.props.hitungHasilSubl(this.state.routeParams).then((result)=>{
    //         //             this.setState({
    //         //                 completed: 50,
    //         //                 tampilCheck: ['inline','inline','none','none','none','none']
    //         //             },()=>{
    //         //                 this.props.hitungHasilIndl(this.state.routeParams).then((result)=>{
    //         //                     this.setState({
    //         //                         completed: 75,
    //         //                         tampilCheck: ['inline','inline','inline','none','none','none']
    //         //                     },()=>{
    //         //                         this.props.hitungHasilStdl(this.state.routeParams).then((result)=>{
    //         //                             this.setState({
    //         //                                 completed: 80,
    //         //                                 tampilCheck: ['inline','inline','inline','inline','none','none']
    //         //                             },()=>{
    //         //                                 this.props.hitungMasterPMP(this.state.routeParams).then((result)=>{
    //         //                                     this.setState({
    //         //                                         completed: 90,
    //         //                                         tampilCheck: ['inline','inline','inline','inline','inline','none']
    //         //                                     },()=>{
    //         //                                         this.props.prosesRaporMutu(this.state.routeParams).then((result)=>{
    //         //                                             this.setState({
    //         //                                                 completed: 100,
    //         //                                                 tampilCheck: ['inline','inline','inline','inline','inline','inline']
    //         //                                             },()=>{
    //         //                                                 this.props.getProsesRapor(this.state.routeParams);
    //         //                                                 this.props.setActiveStep(2);
    //         //                                                 this.props.getTimeline(this.state.routeParams);

    //         //                                                 this.props.getSekolah(this.state.routeParams).then((result)=>{
                                                                
    //         //                                                     this.setState({
    //         //                                                         ...this.state,
    //         //                                                         routeParams: {
    //         //                                                             ...this.state.routeParams,
    //         //                                                             keterangan: JSON.parse( localStorage.getItem('user') ).nama + ' melakukan penghitungan rapor mutu sekolah untuk ' + this.props.sekolah.nama,
    //         //                                                             tautan: '/HasilRaporMutu',
    //         //                                                             tujuan_notifikasi_id: 1,
    //         //                                                             jenis_notifikasi_id: 4
    //         //                                                         }
    //         //                                                     });
                                                                
    //         //                                                     this.props.setNotifikasi(this.state.routeParams);
    //         //                                                 });
    //         //                                             })
    //         //                                         });
    //         //                                     });
    //         //                                 });
    //         //                             });
    //         //                         });
    //         //                     });
    //         //                 });
    //         //             });
    //         //         });
    //         //     });
    //         // });
            
    //     })
    // }

    componentWillMount  = () => {

        this.setState({
            routeParams: {
                ...this.state.routeParams,
                jenis_rapor_id: localStorage.getItem('jenis_rapor_id'),
                pengguna_id: JSON.parse( localStorage.getItem('user') ).pengguna_id,
                sekolah_id: JSON.parse( localStorage.getItem('user') ).sekolah_id,
                token: localStorage.getItem('jwt_token'),
                tahun: localStorage.getItem('tahun'),
                instrumen_id: localStorage.getItem('instrumen_id')
            }
        },()=>{
            this.props.getProsesRapor(this.state.routeParams).then((result)=>{
                // console.log(this.props.proses_rapor_mutu);
            });
        });
    }

    // progress = () => {
    //     const { completed } = this.state;
    //     if (completed === 100) {
    //       this.setState({ completed: 100 });
    //     } else {
    //       const diff = (completed+1)
    //       this.setState({ completed: Math.min(completed + diff, 100) });
    //     }
    // };

    render()
    {
        // const {classes} = this.props;
        // const steps = getSteps();
        
        return (
            <FuseAnimate
                animation="transition.slideLeftIn"
                duration={400}
                delay={400}
            >
            <div style={{width: '100%', padding: '10px'}} className="konten-utama">
            <Dialog
                    open={this.state.prosesGagal}
                    // onClose={this.handleCloseDialogBlocking}
                    aria-labelledby="alert-rapor-mutu-belum"
                    aria-describedby="alert-rapor-mutu-belum"
                >
                    <DialogTitle id="alert-rapor-mutu-belum-title">Peringatan</DialogTitle>
                    <DialogContent>
                        Sekolah tidak ditemukan di aplikasi Dapodik. Mohon pastikan kembali bahwa Sekolah Anda telah terregistrasi pada aplikasi dapodik Anda!
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={()=>this.setState({prosesGagal: false})} color="secondary" variant="contained">
                                Tutup dan Batalkan Proses Hitung Rapor Mutu
                            </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.prosesJalan}
                    // onClose={this.handleCloseDialogBlocking}
                    aria-labelledby="alert-rapor-mutu-belum"
                    aria-describedby="alert-rapor-mutu-belum"
                >
                    <DialogTitle id="alert-rapor-mutu-belum-title">Proses Hitung Rapor Mutu ...</DialogTitle>
                    <DialogContent>
                        {!this.state.prosesStatus.proses6 &&
                        <DialogContentText>
                            Mohon jangan tutup jendela browser Anda sebelum proses ini selesai!
                        </DialogContentText>
                        }
                        {this.state.prosesStatus.proses6 &&
                        <DialogContentText>
                            Proses telah selesai
                        </DialogContentText>
                        }
                        <br/>
                        {/* <DialogContentText id="alert-rapor-mutu-belum-description"> */}
                        {!this.state.prosesStatus.proses6 &&
                        <LinearProgress color="primary" className="progresUmum" style={{width: '100%', height: '10px'}}/>
                        }
                        <List component="nav" aria-label="main mailbox folders">
                            <ListItem>
                                {this.state.prosesStatus.proses1 &&
                                <span>
                                    <CheckCircleIcon style={{fontSize:'20px',color:'green'}}/>&nbsp; <span style={{color:'green'}}>Validasi data sekolah dari dapodik (100%)</span>
                                </span>
                                }
                                {!this.state.prosesStatus.proses1 &&
                                <span>
                                    <CheckCircleIcon style={{fontSize:'20px',color:'#cccccc'}}/>&nbsp; <span style={{color:'#cccccc'}}>Validasi data sekolah dari dapodik (0%)</span>
                                </span>
                                }
                            </ListItem>
                            <ListItem>
                                {this.state.prosesStatus.proses2 &&
                                <span>
                                    <CheckCircleIcon style={{fontSize:'20px',color:'green'}}/>&nbsp; <span style={{color:'green'}}>Membaca dan memroses data dapodik sekolah dari dapodik ({parseFloat(parseInt(this.state.prosesStatus.persenProses)/23*100).toFixed(0)}%)</span>
                                </span>
                                }
                                {!this.state.prosesStatus.proses2 &&
                                <span>
                                    <CheckCircleIcon style={{fontSize:'20px',color:'#cccccc'}}/>&nbsp; <span style={{color:'#cccccc'}}>Membaca dan memroses data dapodik sekolah dari dapodik ({parseFloat(parseInt(this.state.prosesStatus.persenProses)/23*100).toFixed(0)}%)</span>
                                </span>
                                }
                            </ListItem>
                            <ListItem>
                                {this.state.prosesStatus.proses3 &&
                                <span>
                                    <CheckCircleIcon style={{fontSize:'20px',color:'green'}}/>&nbsp; <span style={{color:'green'}}>Menghitung rapor mutu berdasarkan data dapodik sekolah (100%)</span>
                                </span>
                                }
                                {!this.state.prosesStatus.proses3 &&
                                <span>
                                    <CheckCircleIcon style={{fontSize:'20px',color:'#cccccc'}}/>&nbsp; <span style={{color:'#cccccc'}}>Menghitung rapor mutu berdasarkan data dapodik sekolah (0%)</span>
                                </span>
                                }
                            </ListItem>
                            <ListItem>
                                {this.state.prosesStatus.proses4 &&
                                <span>
                                    <CheckCircleIcon style={{fontSize:'20px',color:'green'}}/>&nbsp; <span style={{color:'green'}}>Menghitung rapor mutu - Sub Indikator (100%)</span>
                                </span>
                                }
                                {!this.state.prosesStatus.proses4 &&
                                <span>
                                    <CheckCircleIcon style={{fontSize:'20px',color:'#cccccc'}}/>&nbsp; <span style={{color:'#cccccc'}}>Menghitung rapor mutu - Sub Indikator (0%)</span>
                                </span>
                                }
                            </ListItem>
                            <ListItem>
                                {this.state.prosesStatus.proses5 &&
                                <span>
                                    <CheckCircleIcon style={{fontSize:'20px',color:'green'}}/>&nbsp; <span style={{color:'green'}}>Menghitung rapor mutu - Indikator (100%)</span>
                                </span>
                                }
                                {!this.state.prosesStatus.proses5 &&
                                <span>
                                    <CheckCircleIcon style={{fontSize:'20px',color:'#cccccc'}}/>&nbsp; <span style={{color:'#cccccc'}}>Menghitung rapor mutu - Indikator (0%)</span>
                                </span>
                                }
                            </ListItem>
                            <ListItem>
                                {this.state.prosesStatus.proses6 &&
                                <span>
                                    <CheckCircleIcon style={{fontSize:'20px',color:'green'}}/>&nbsp; <span style={{color:'green'}}>Menghitung rapor mutu - Standar (100%)</span>
                                </span>
                                }
                                {!this.state.prosesStatus.proses6 &&
                                <span>
                                    <CheckCircleIcon style={{fontSize:'20px',color:'#cccccc'}}/>&nbsp; <span style={{color:'#cccccc'}}>Menghitung rapor mutu - Standar (0%)</span>
                                </span>
                                }
                            </ListItem>
                        </List>
                        {/* </DialogContentText> */}
                    </DialogContent>
                    <DialogActions>
                        {this.state.prosesStatus.proses6 &&
                            <Button onClick={()=>this.setState({prosesJalan: false})} color="secondary" variant="contained">
                                Tutup Jendela Proses
                            </Button>
                        }
                        {this.state.prosesStatus.proses6 &&
                            <Button onClick={()=>this.props.history.push('/HasilRaporMutu')} color="primary" variant="contained">
                                Buka Hasil Rapor Mutu
                            </Button>
                        }
                        {/* <Button onClick={()=>this.props.history.push('/PerangkatKuesioner')} color="primary" disabled={this.state.disableDialogButton}>
                            Isi Instrumen Kuesioner
                        </Button>
                        <Button onClick={()=>this.props.history.push('/')} color="primary" autoFocus disabled={this.state.disableDialogButton}>
                            Beranda
                        </Button> */}
                    </DialogActions>
                </Dialog>
                
                <Paper className="p-16" style={{textAlign:'center'}}>
                    {localStorage.getItem('jenis_rapor_id') === "1" && 
                    <Button size="large" variant="contained" color="primary" onClick={this.prosesRaporMutu} disabled={this.state.disabledButtonTigaResponden}>
                        <AssignmentTurnedInIcon/> &nbsp; Hitung Rapor Mutu Tiga Responden
                    </Button>
                    }
                    {localStorage.getItem('jenis_rapor_id') === "2" && 
                    // <Button size="large" variant="contained" color="primary" onClick={this.prosesRaporMutu} disabled={false}>
                    <Button size="large" variant="contained" color="primary" onClick={this.prosesRaporMutu} disabled={this.state.disabledButtonSekolah}>
                        <AssignmentTurnedInIcon/> &nbsp; Hitung Rapor Mutu Sekolah
                    </Button>
                    }
                    <br/>
                    <br/>
                    {localStorage.getItem('jenis_rapor_id') === "2" &&
                    <Paper elevation={1}>
                        <Grid container>
                            <Grid item xs={6} sm={6} style={{borderRight:'1px dashed #ccc', background:'#E1F5FE', paddingBottom: '10px'}}>
                                <Typography variant="subheading">
                                    Kepala Sekolah
                                </Typography>
                                {this.state.check.kepsek === true && <CheckCircleIcon style={{fontSize:'60px',color:'green'}} />}
                                {this.state.check.kepsek === false && <CancelIcon style={{fontSize:'60px',color:'#ccc'}} />}
                                <Typography variant="caption">
                                    Minimal Responden: 1
                                </Typography>
                                <Typography variant="caption">
                                    Responden Selesai: {this.state.kemajuan_kepsek.selesai}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} sm={6} style={{borderRight:'1px dashed #ccc', background:'#E3F2FD'}}>
                                <Typography variant="subheading">
                                    Guru
                                </Typography>
                                {this.state.check.ptk === true && <CheckCircleIcon style={{fontSize:'60px',color:'green'}} />}
                                {this.state.check.ptk === false && <CancelIcon style={{fontSize:'60px',color:'#ccc'}} />}
                                <Typography variant="caption">
                                    Minimal Responden: {this.state.kemajuan_ptk.total < 10 && this.state.kemajuan_ptk.total} {this.state.kemajuan_ptk.total >= 10 && 10}
                                </Typography>
                                <Typography variant="caption">
                                    Responden Selesai: {this.state.kemajuan_ptk.selesai}
                                </Typography>
                            </Grid>
                            {/* <Grid item xs={6} sm={3} style={{borderRight:'1px dashed #ccc', background:'#E0F2F1', paddingBottom: '10px'}}>
                                <Typography variant="subheading">
                                    Peserta Didik
                                </Typography>
                                {this.state.check.pd === true && <CheckCircleIcon style={{fontSize:'60px',color:'green'}} />}
                                {this.state.check.pd === false && <CancelIcon style={{fontSize:'60px',color:'#ccc'}} />}
                                <Typography variant="caption">
                                    Minimal Responden: {this.state.kemajuan_pd.total < 15 && this.state.kemajuan_pd.total > 0 && this.state.kemajuan_pd.total} {this.state.kemajuan_pd.total >= 15 && 15} {this.state.kemajuan_pd.total < 1 && 15} 
                                </Typography>
                                <Typography variant="caption">
                                    Responden Selesai: {this.state.kemajuan_pd.selesai}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} sm={3} style={{background:'#E0F7FA', paddingBottom: '10px'}}>
                                <Typography variant="subheading">
                                    Komite Sekolah
                                </Typography>
                                {this.state.check.komite === true && <CheckCircleIcon style={{fontSize:'60px',color:'green'}} />}
                                {this.state.check.komite === false && <CancelIcon style={{fontSize:'60px',color:'#ccc'}} />}
                                <Typography variant="caption">
                                    Minimal Responden: 3
                                </Typography>
                                <Typography variant="caption">
                                    Responden Selesai: {this.state.kemajuan_komite.selesai}
                                </Typography>
                            </Grid> */}
                            <Grid item xs={12} style={{background:'#E65100', color:'white'}} hidden={!this.state.showPeringatanSekolah}>
                                <Grid container>
                                    <Grid item xs={2} sm={1} style={{paddingTop:'10px'}}>
                                        <WarningRoundedIcon style={{fontSize:'40px'}}/>
                                    </Grid>
                                    <Grid item xs={10} sm={11} style={{textAlign:'left',paddingTop:'10px',paddingBottom:'10px'}}>
                                        <b>Sekolah Anda belum bisa melakukan penghitungan rapor mutu sekolah</b> apabila responden kepala sekolah dan guru yang selesai belum mencapai jumlah minimal
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                    }
                    {localStorage.getItem('jenis_rapor_id') === "1" &&
                    <Paper elevation={1}>
                        <Grid container>
                            <Grid item xs={12} sm={4} style={{borderRight:'1px dashed #ccc', background:'#E3F2FD', paddingBottom: '10px'}}>
                                <Typography variant="subheading">
                                    Guru
                                </Typography>
                                {this.state.check.ptk === true && <CheckCircleIcon style={{fontSize:'60px',color:'green'}} />}
                                {this.state.check.ptk === false && <CancelIcon style={{fontSize:'60px',color:'#ccc'}} />}
                                <Typography variant="caption">
                                    Minimal Responden: {this.state.kemajuan_ptk.total < 10 && this.state.kemajuan_ptk.total} {this.state.kemajuan_ptk.total >= 10 && 10}
                                </Typography>
                                <Typography variant="caption">
                                    Responden Selesai: {this.state.kemajuan_ptk.selesai}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4} style={{borderRight:'1px dashed #ccc', background:'#E0F2F1', paddingBottom: '10px'}}>
                                <Typography variant="subheading">
                                    Peserta Didik
                                </Typography>
                                {this.state.check.pd === true && <CheckCircleIcon style={{fontSize:'60px',color:'green'}} />}
                                {this.state.check.pd === false && <CancelIcon style={{fontSize:'60px',color:'#ccc'}} />}
                                <Typography variant="caption">
                                    Minimal Responden: {this.state.kemajuan_pd.total < 15 && this.state.kemajuan_pd.total} {this.state.kemajuan_pd.total >= 15 && 15}
                                </Typography>
                                <Typography variant="caption">
                                    Responden Selesai: {this.state.kemajuan_pd.selesai}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4} style={{background:'#E0F7FA', paddingBottom: '10px'}}>
                                <Typography variant="subheading">
                                    Komite Sekolah
                                </Typography>
                                {this.state.check.komite === true && <CheckCircleIcon style={{fontSize:'60px',color:'green'}} />}
                                {this.state.check.komite === false && <CancelIcon style={{fontSize:'60px',color:'#ccc'}} />}
                                <Typography variant="caption">
                                    Minimal Responden: 3
                                </Typography>
                                <Typography variant="caption">
                                    Responden Selesai: {this.state.kemajuan_komite.selesai}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} className="p-8" style={{background:'#E65100', color:'white'}} hidden={!this.state.showPeringatanTigaResponden}>
                                <Grid container>
                                    <Grid item xs={2} sm={1} style={{paddingTop:'10px'}}>
                                        <WarningRoundedIcon style={{fontSize:'40px'}}/>
                                    </Grid>
                                    <Grid item xs={10} sm={11} style={{textAlign:'left',paddingTop:'10px',paddingBottom:'10px',background:'#E65100', color:'white'}}>
                                        <b>Belum bisa menghitung rapor mutu tiga responden</b> apabila responden guru, peserta didik, dan komite yang selesai belum mencapai jumlah minimal
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                    }
                    {this.state.jenis_rapor_id === "1" &&
                    <Paper elevation={1} className="p-8" style={{background:'#E65100', color:'white'}}>
                        <Grid container>
                            <Grid item xs={1}>
                                <WarningRoundedIcon style={{fontSize:'50px'}}/>
                            </Grid>
                            <Grid item xs={11} style={{textAlign:'left'}}>
                                <b>Belum bisa menghitung rapor mutu tiga responden</b> apabila responden guru, peserta didik, dan komite yang selesai belum mencapai jumlah minimal
                            </Grid>
                        </Grid>
                    </Paper>
                    }
                    {this.state.jenis_rapor_id === "2" &&
                    <Paper elevation={1} className="p-8" style={{background:'#E65100', color:'white'}}>
                        <Grid container>
                            <Grid item xs={1}>
                                <WarningRoundedIcon style={{fontSize:'50px'}}/>
                            </Grid>
                            <Grid item xs={11} style={{textAlign:'left'}}>
                                <b>Belum bisa menghitung rapor mutu sekolah</b> apabila responden kepala sekolah dan guru yang selesai belum mencapai jumlah minimal
                            </Grid>
                        </Grid>
                    </Paper>
                    }
                </Paper>
                <br/>
                {/* <Paper elevation={1}> */}
                <Timeline/>
                {/* </Paper> */}
                <br/>
                <Paper className="p-8" style={{borderBottomLeftRadius:'0px',borderBottomRightRadius: '0px'}}>
                    <Typography variant="subheading">Riwayat Hitung Rapor Mutu</Typography>
                </Paper>
                <Paper  style={{borderTopLeftRadius:'0px',borderTopRightRadius: '0px'}}>
                    <Pagination
                    limit={20}
                    offset={this.state.offset}
                    total={this.props.proses_rapor_mutu.total}
                    innerButtonCount={1}
                    outerButtonCount={1}
                    style={{width: '100%'}}
                    onClick={this.loadData}
                    />
                </Paper>
                <br/>
                <Paper className="p-8">
                    <Paper elevation={0} className="hilangDiMobile p-8">
                        <Grid container>
                            <Grid item xs={12} sm={3}>
                                Tanggal
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                Status Proses
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                Jenis Rapor
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                Pemroses
                            </Grid>
                        </Grid>
                        <Divider/>
                    </Paper>
                    {this.props.proses_rapor_mutu.rows.map((option)=>{
                        return (
                            <Paper elevation={0} className="p-8">
                                <Grid container>
                                    <Grid item xs={12} sm={3}>
                                        <span className="hilangDiDesktop">Tanggal: </span> <b>{option.tanggal}</b>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                    <span className="hilangDiDesktop">Status: </span> <b>{option.status_proses}</b>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                    <span className="hilangDiDesktop">Jenis Rapor: </span> <b>{option.jenis_rapor_id_str}</b>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                    <span className="hilangDiDesktop">Pemroses: </span> <b>{option.pengguna_id_str}</b>
                                    </Grid>
                                </Grid>
                                <Divider/>
                            </Paper>
                        )
                    })}
                </Paper>
                <Dialog
                    open={this.state.openDialog}
                    fullWidth={this.state.fullWidth}
                    maxWidth={this.state.maxWidth}
                >
                    <DialogContent id="loading-dialog" style={{textAlign: 'center'}}>
                        <Typography variant="h5">Memroses Rapor Mutu...</Typography>
                        <br/>
                        <LinearProgress color="primary" variant="determinate" value={this.state.completed} style={{height:'20px'}}/>
                        
                        <Paper elevation={0} style={{border:'1px solid #ccc', marginTop: '5px'}} className="p-8">
                            <br/>
                            <Grid container>
                                <Grid item xs={10} style={{textAlign:'left', height: '40px'}}>
                                    Menghitung skor final pertanyaan
                                    {/* <Divider/>   */}
                                </Grid>
                                <Grid item xs={2} style={{textAlign:'right'}}>
                                    <CheckIcon style={{color:'green', display: this.state.tampilCheck[0] }}/>
                                    {/* <Divider/>   */}
                                </Grid>
                                <Grid item xs={10} style={{textAlign:'left', height: '40px'}}>
                                    Menghitung hasil sub-indikator SNP
                                </Grid>
                                <Grid item xs={2} style={{textAlign:'right'}}>
                                    <CheckIcon style={{color:'green', display: this.state.tampilCheck[1]}}/>
                                </Grid>
                                <Grid item xs={10} style={{textAlign:'left', height: '40px'}}>
                                    Menghitung hasil indikator SNP
                                </Grid>
                                <Grid item xs={2} style={{textAlign:'right'}}>
                                    <CheckIcon style={{color:'green', display: this.state.tampilCheck[2]}}/>
                                </Grid>
                                <Grid item xs={10} style={{textAlign:'left', height: '40px'}}>
                                    Menghitung hasil standar SNP
                                </Grid>
                                <Grid item xs={2} style={{textAlign:'right'}}>
                                    <CheckIcon style={{color:'green', display: this.state.tampilCheck[3]}}/>
                                </Grid>
                                <Grid item xs={10} style={{textAlign:'left', height: '40px'}}>
                                    Mencetak Rapor Mutu Sekolah
                                </Grid>
                                <Grid item xs={2} style={{textAlign:'right'}}>
                                    <CheckIcon style={{color:'green', display: this.state.tampilCheck[4]}}/>
                                </Grid>
                                <Grid item xs={10} style={{textAlign:'left', height: '40px'}}>
                                    Mencatat riwayat proses rapor mutu
                                </Grid>
                                <Grid item xs={2} style={{textAlign:'right'}}>
                                    <CheckIcon style={{color:'green', display: this.state.tampilCheck[5]}}/>
                                </Grid>
                                {this.state.tampilCheck[4] === 'inline' &&
                                <Grid item xs={12}>
                                    <Button color="secondary" variant="contained" onClick={()=>this.setState({openDialog:false})}>
                                        <CheckIcon/> &nbsp; Selesai
                                    </Button>
                                    <br/>
                                    <br/>
                                    <Paper style={{background:'#43A047', color:'white'}}>
                                        <Grid container>
                                            <Grid item xs={2} sm={2} style={{paddingTop:'10px'}}>
                                                <InfoRoundedIcon style={{fontSize:'40px'}}/>
                                            </Grid>
                                            <Grid item xs={10} sm={10} style={{textAlign:'left',paddingTop:'20px',paddingBottom:'10px', color:'white'}}>
                                                {/* Proses Penghitungan rapor mutu telah selesai. Silakan cek hasilnya pada tautan di bawah ini */}
                                                {/* <br/>
                                                <br/> */}
                                                {/* <Button color="primary" variant="contained" onClick={()=>this.goTolink('/HasilRaporMutu')}>
                                                    Buka Hasil Rapor Mutu
                                                </Button> */}
                                                Proses Hitung Rapor Mutu telah selesai. Hasil Rapor Mutu Sementara akan dikiriman ke server untuk diolah lebih lanjut selama kurang lebih 2-4 minggu. Hasil Rapor Mutu yang sudah selesai bisa dilihat di Tautan di Bawah ini:<br/>
                                                <Button color="primary" variant="contained" onClick={()=>window.open('http://rapormutu.pmp.kemdikbud.go.id')}>
                                                    Buka Hasil Rapor Mutu
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                                }
                            </Grid>
                        </Paper>
                    </DialogContent>
                </Dialog>
            </div>
            </FuseAnimate>
        )
    }

}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getSekolah: Actions.getSekolah,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        getKemajuanTotal: Actions.getKemajuanTotal,
        getPeringkatPengisian: Actions.getPeringkatPengisian,
        setLoading: Actions.setLoading,
        setJudul: Actions.setJudul,
        prosesRaporMutu: Actions.prosesRaporMutu,
        getProsesRapor: Actions.getProsesRapor,
        hitungFinalSkor: Actions.hitungFinalSkor,
        hitungHasilSubl: Actions.hitungHasilSubl,
        hitungHasilIndl: Actions.hitungHasilIndl,
        hitungHasilStdl: Actions.hitungHasilStdl,
        hitungMasterPMP: Actions.hitungMasterPMP,
        setActiveStep: Actions.setActiveStep,
        getTimeline: Actions.getTimeline,
        setNotifikasi: Actions.setNotifikasi,
        prosesDatamart: Actions.prosesDatamart,
        prosesRaporMutuDapodik: Actions.prosesRaporMutuDapodik,
        prosesSubIndikator: Actions.prosesSubIndikator,
        prosesIndikator: Actions.prosesIndikator,
        prosesStandar: Actions.prosesStandar,
        prosesLogRapor: Actions.prosesLogRapor,
        prosesNonDatamart: Actions.prosesNonDatamart,
        cekSekolah: Actions.cekSekolah
    }, dispatch);
}

function mapStateToProps({ Sekolah, Instrumen, RaporMutu }) {

    return {
        sekolah: Sekolah.sekolah,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        kemajuan_total: Instrumen.kemajuan_total,
        peringkat_pengisian: Instrumen.peringkat_pengisian,
        proses_rapor_mutu: RaporMutu.proses_rapor_mutu,
        final_skor: RaporMutu.final_skor,
        active_step: RaporMutu.active_step
    }
}

// export default withStyles(styles, {withTheme: true})(Beranda);
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(RiwayatRaporMutu)));



// WEBPACK FOOTER //
// ./src/main/content/RaporMutu/RiwayatRaporMutu.js